'use strict';
const angular = require('angular');

export class jsonViewerComponent {
  /*@ngInject*/
  constructor() {
  }

  $onInit() {
    this.data = this.resolve.config.data;
  };
}

export default angular.module('conduu.ap.components.jsonViewer', [])
  .component('jsonViewer', {
    template: '<json-view value="$ctrl.data"></json-view>',
    bindings: {
      resolve: '<',
      config: '<',
      close: '&',
      dismiss: '&'
    },
    controller: jsonViewerComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/~ap/components/json-view/json-view.component.js